// extracted by mini-css-extract-plugin
export default {"root":"search_root__HkpKN","input":"search_input__ATbho"};